module.exports = __webpack_public_path__ + "img/portrait-rank-20@3x.fdb734af.png";